import colorMap from '../asset/scss/settings/_brand-colors.module.scss'

const brandToColor = (brand) => {
  return {
    color: colorMap[brand],
    primaryColor: colorMap[`${brand}Primary`],
    secondaryColor: colorMap[`${brand}Secondary`]
  }
}

export default brandToColor
